import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Auth, API, Storage } from 'aws-amplify';

import Map from '../Util/Map'

let customPrefix = {
    public: 'public/',
    protected: 'protected/',
    private: 'jobs/*/'
}

class Test extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAuth: {},
            uploadFileName: '',
            uploadFileData: '',
            uploadedFiles: [],
            uploadFileError: false,
            selectedFile: '',
            loadFile: '',
            selectedFileToDelete: '',
            requestId: '',
            geojson: undefined,
            drawPolygon: false,
            clearPolygons: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.changeBoolean = this.changeBoolean.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    componentDidMount() {
        Auth.currentAuthenticatedUser().then(user => {
            this.setState({currentAuth: user.attributes});
            customPrefix.private = `jobs/${this.state.currentAuth['custom:organization']}/`
        }).catch(err => console.log(err))

        this.listUserData()
    }

    listUserData() {
        let options =  {
            customPrefix: customPrefix,
            level: 'private',
        }
        Storage.list('data/', options)
            .then(result => {
                this.setState({uploadedFiles: result});
                this.loadFile()
            })
            .catch(err => console.log(err));
    }

    uploadFile(e) {
        let file = e.target.files[0];
        let options =  {
            customPrefix: customPrefix,
            level: 'private',
            contentType: file.type
        }

        this.setState({uploadFileName: file.name});
        Storage.put(`data/${file.name}`, file, options)
            .then (result => {
                console.log(result)
                this.setState({uploadFileError: false})
            })
            .catch(err => {
                console.log(err)
                this.setState({uploadFileError: true})
            });
    }

    loadFile() {
        let options =  {
            customPrefix: customPrefix,
            level: 'private',
        }
        Storage.get(this.state.selectedFile, options)
            .then(result => {
                this.setState({loadFile: result})
            })
            .catch(err => console.log(err));
    }

    showImage(){
        return (
            <div>
                <img src={this.state.loadFile} alt="" style={{ width: 300}}/>
            </div>
        )
    }

    removeFile(){
        let options =  {
            customPrefix: customPrefix,
            level: 'private',
        }
        Storage.remove(this.state.selectedFileToDelete, options)
            .then(result => console.log(result))
            .catch(err => console.log(err));
    }

    api_get() {
        let options = {
            headers: {},
            response: true
        }

        API.get("AQcast", "/request/", options)
            .then(response => console.log(response))
            .catch(error => console.log(error))
    }

    api_get_availablemodels() {
        let options = {
            headers: {},
            response: true
        }

        API.get("AQcast", "/request/availablemodels/", options)
            .then(response => {
                console.log(response.data.models)
            })
            .catch(error => console.log(error))
    }

    api_post_aermod() {
        let request = {
            "AERSFC_1":"3",
            "AERSFC_2":"3",
            "AERSFC_3":"5",
            "AERSFC_4":"5",
            "AERSFC_5":"5",
            "AERSFC_6":"1",
            "AERSFC_7":"1",
            "AERSFC_8":"1",
            "AERSFC_9":"2",
            "AERSFC_10":"2",
            "AERSFC_11":"2",
            "AERSFC_12":"3",
            "AERSFC_CHECK":false,
            "BLDG1":[
                 ["b1","1","1"],
                 ["b2","2","2"]
             ],
            "BLDG_FILE":"/nas/CMAQ_Scratch/stuff.kml",
            "BLDG_NO":2,
            "CO_CHECK":false,
            "FENCE_FILE":"",
            "ISR":"0.5",
            "LEAD_CHECK":false,
            "MMIF_CHECK":false,
            "NO2_CHECK":true,
            "ONSITE_FILE":"",
            "OTHER_CHECK":false,
            "OZONE_VAL":"0.0",
            "PERIOD":"recent",
            "PM10_CHECK":false,
            "PM25_CHECK":false,
            "REC_FILE":"",
            "REC_G1LB":"0",
            "REC_G1S":"50",
            "REC_G1UB":"500",
            "REC_G2LB":"500",
            "REC_G2S":"0",
            "REC_G2UB":"2000",
            "REC_G3LB":"2000",
            "REC_G3S":"0",
            "REC_G3UB":"6000",
            "RUN_OPT":"default",
            "SFC_MET_OPT":"0",
            "SO2_CHECK":false,
            "SO_TYPE":"Point",
            "STACK_NO":2,
            "STK1":[
                ["stack1","43.2348","-107.4756","15","1.5","375","3.5"],
                ["stack2","43.2348","-107.4756","17","1.7","377","3.7"]
            ],
            "STK1L":[
                ["0.1","0.0","0.0","0.0","0.0","0.0","0.0"],
                ["0.7","0.0","0.0","0.0","0.0","0.0","0.0"]
            ],
            "STK1S":[
                ["0.1","0.0","0.0","0.0","0.0","0.0","0.0"],
                ["0.7","0.0","0.0","0.0","0.0","0.0","0.0"]
            ],
            "STK_FILE":"",
            "UPA_MET_OPT":"0",
            "USRLAT":"42.18726",
            "USRLON":"-107.98776",
            "UTMX":"",
            "UTMY":"",
            "UTMZ":""
        }

        let options = {
            body: request,
            headers: {},
            response: true
        }

        API.post("AQcast", "/request/aermod/", options)
                        .then(response => {
                            this.setState({requestId: response.data.requestId});
                            console.log(response)}
                        )
                        .catch(error => console.log(error))
    }

    api_post_metsite() {
        let request = {
            'latlon' : [42.361145, -71.057083]
        }

        let options = {
            body: request,
            headers: {},
            response: true
        }

        API.post("AQcast", "/request/metsite/", options)
                        .then(response => {
                            console.log(response)}
                        )
                        .catch(error => console.log(error))
    }

    uploadShpFile(e) {
        let file = e.target.files[0];

        this.setState({
            geojson: undefined
        })

        window.loadshp({
            url: file, // path or your upload file
            encoding: 'big5', // default utf-8
            EPSG: 3826 // default 4326
        }, function(geojson) {
            this.setState({
                geojson: geojson
            })
            console.log(geojson)
        }.bind(this))
    }

    changeBoolean(varName){
        let boolValue = this.state[varName]
        this.setState({[varName]: !boolValue})

    }



    render() {
        const { classes } = this.props;

        return (
            <div>
                <b className={classNames(classes.margin)}>Tests for passing Auth information through props</b>
                <div>
                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => console.log(this.props)}
                    > Props</Button>

                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => console.log(this.props.authData.signInUserSession.idToken)}
                    > Access Token</Button>

                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => console.log(this.props.authData.signInUserSession.idToken.jwtToken)}
                    > JWT Token</Button>
                </div>

               <b className={classNames(classes.margin)}>Tests for submitting requests using Amplify</b>
                <div>
                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => this.api_get()}
                    > GET Request </Button>

                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => this.api_get_availablemodels()}
                    > GET Models </Button>

                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => this.api_post_aermod()}
                    > POST AERMOD </Button> {this.state.requestId}

                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => this.api_post_metsite()}
                    > POST METSITE  </Button> {this.state.requestId}

                </div>
                <div>
                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => {Auth.currentAuthenticatedUser().then(user => console.log(user)).catch(err => console.log(err))}
                        }
                    > Current User Auth </Button>
                </div>
                <div>
                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        onClick={() => {Auth.currentCredentials().then(creds => console.log(creds)).catch(err => console.log(err))}
                        }
                    > Current User Identity </Button>
                </div>
                <div>
                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        component="label"
                    > Upload File

                        <input type="file"
                               style={{ display: 'none' }}
                               onChange={(e) => this.uploadFile(e)}
                        />
                </Button>
                {this.state.uploadFileError ? <b style={{color:'red'}}> {this.state.uploadFileName} excedes upload size limit</b> : this.state.uploadFileName}

                </div>

                <div>
                    <b> Select File to Display </b>

                    <TextField
                        className={classNames(classes.margin, classes.textField)}
                        select
                        style={{width: '194px'}}
                        label="Files"
                        name="selectedFile"
                        value={this.state.selectedFile}
                        onClick={() => this.listUserData()}
                        onChange={this.handleInputChange}>

                        {this.state.uploadedFiles.map(file => (
                            <MenuItem key={file.key} value={file.key}>
                                {file.key}
                            </MenuItem>
                        ))}
                    </TextField>

                    {this.state.loadFile !== '' && this.showImage()}
                </div>


                <div>
                    <b> Select File to Delete </b>

                    <TextField
                        className={classNames(classes.margin, classes.textField)}
                        select
                        style={{width: '194px'}}
                        label="Files"
                        name="selectedFileToDelete"
                        value={this.state.selectedFileToDelete}
                        onClick={() => this.listUserData()}
                        onChange={this.handleInputChange}>

                        {this.state.uploadedFiles.map(file => (
                            <MenuItem key={file.key} value={file.key}>
                                {file.key}
                            </MenuItem>
                        ))}
                    </TextField>

                    <Button
                        className={classNames(classes.margin, classes.textField)}
                        variant="contained"
                        color="primary"
                        component="label"
                        onClick={() => this.removeFile()}
                    > Delete File
                    </Button>
                </div>

                <div>
                    <Button
                        className={classNames(classes.margin)}
                        variant="contained"
                        color="primary"
                        component="label"
                    > Upload Shp Zip File

                        <input type="file"
                               style={{ display: 'none' }}
                               onChange={(e) => this.uploadShpFile(e)}
                        />
                    </Button>
                    <Button
                        className={classNames(classes.margin)}
                        variant="contained"
                        color="primary"
                        component="label"
                        onClick={() =>  this.changeBoolean('drawPolygon')}
                    > Draw Polygon </Button>
                    <Button
                        className={classNames(classes.margin)}
                        variant="contained"
                        color="primary"
                        component="label"
                        onClick={() => this.changeBoolean('clearPolygons')}
                    > Clear Polygons </Button>

                <Map
                    classes={this.props.classes}
                    geojson={this.state.geojson}
                    drawPolygon={this.state.drawPolygon}
                    clearPolygons={this.state.clearPolygons}
                    changeBoolean={this.changeBoolean} />

                </div>

            </div>
        );
    }
}

Test.propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    }, root: {
        display: "flex",
        flexWrap: "wrap"
    }, margin: {
        margin: theme.spacing.unit
    } ,withoutLabel: {
        marginTop: theme.spacing.unit * 3
    }, textField: {
        flexBasis: 200
    }
});

export default withStyles(styles)(Test);
